<template>
  <div>
    <v-card flat>
      <v-card-text>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Full Name:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.firstName ? values.firstName : "-" }}
              {{ values.fatherName ? values.fatherName : "-" }}
              {{ values.grandFatherName ? values.grandFatherName : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Sex:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.sex ? values.sex : "-" }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Id-No:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.idNo ? values.idNo : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Background Profession:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{
                values.backgroundProfession ? values.backgroundProfession : "-"
              }}
            </p>
          </div>
        </div>
      </v-card-text>

      <div class="title" style="background-color: #f3f3f3; padding: 5px 24px;">
        Educational Information
      </div>

      <v-card-text>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">
              Department:
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.department ? values.department : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Education Program:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values?.educationProgram?.name ? values.educationProgram.name : "-" }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Level Of Education:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values?.levelOfStudy?.name ? values.levelOfStudy.name : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Entry Year:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.entryYear ? values.entryYear : "-" }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">
              Expected Year of Graduation:
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{
                values.expectedYear
                    ? values.expectedYear
                    : "-"
              }}
            </p>
          </div>
          <div class="w-1/2 h-12">
          </div>
          <div class="w-1/2 h-12">

          </div>
        </div>
      </v-card-text>

      <div class="title" style="background-color: #f3f3f3; padding: 5px 24px;">
        About University
      </div>

      <v-card-text>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">
              Higher Learning Institution:
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{
                values?.university?.name
                    ? values.university.name
                    : "-"
              }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Ownership:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values?.university?.ownership?.name ? values.university.ownership.name : "-" }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Generation Level:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values?.university?.generation ? values.university.generation : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Region:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values?.university?.region?.name ? values.university.region?.name : "-" }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Town:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values?.university?.town ? values.university.town : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Is Withdrawn?</p>
          </div>
          <div class="w-1/2 h-12">
            <div class=".text-base">
              <span style="float: left">
                <v-chip :color="getColor(values.isWithdrawn)" dark>
                  {{ values.isWithdrawn }}
                </v-chip>
              </span>
            </div>
          </div>

        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    graduates: Object,
  },
  data() {
    return {
      values: [],
    };
  },
  created() {
    if (this.graduates != null) {
      this.values = this.graduates;
    }
  },
  methods: {
    getColor(isActive) {
      if (isActive == "No") return "red";
      else return "green";
    },
  }
};
</script>
